var chunkMapping = {
	"100": [
		20100
	],
	"2847": [
		12847
	],
	"6910": [
		36910
	],
	"6947": [
		96947
	],
	"7131": [
		17131
	],
	"9048": [
		89048
	]
};
var idToExternalAndNameMapping = {
	"12847": [
		"default",
		"./Module",
		57420
	],
	"17131": [
		"default",
		"./Module",
		55942
	],
	"20100": [
		"default",
		"./Module",
		46352
	],
	"36910": [
		"default",
		"./Module",
		91640
	],
	"89048": [
		"default",
		"./Module",
		21996
	],
	"96947": [
		"default",
		"./Module",
		56856
	]
};
var idToRemoteMap = {
	"12847": [
		{
			"externalType": "script",
			"name": "admin",
			"externalModuleId": 57420
		}
	],
	"17131": [
		{
			"externalType": "script",
			"name": "ksef",
			"externalModuleId": 55942
		}
	],
	"20100": [
		{
			"externalType": "script",
			"name": "auth",
			"externalModuleId": 46352
		}
	],
	"36910": [
		{
			"externalType": "script",
			"name": "invoices",
			"externalModuleId": 91640
		}
	],
	"89048": [
		{
			"externalType": "script",
			"name": "crm",
			"externalModuleId": 21996
		}
	],
	"96947": [
		{
			"externalType": "script",
			"name": "account",
			"externalModuleId": 56856
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}